// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"836f3560","509":"3462d7d7","787":"9a7cd588"}[chunkId] + ".chunk.js";
};